<template>
  <v-container grid-list-xl fluid ma-3 text-xs-center>
    <v-layout justify-center wrap row v-if="!error">
      <v-flex xs10 display-1 ma-3>
        Invitation
      </v-flex>
      <v-flex xs8 elevation-2 white pa-3 style="max-width:550px">
        
        <p class="text-xs-center title mt-3" style="font-weight: normal">Do you want to join <span style="font-weight:bold">{{invitation.School.name}}</span>?</p>
        
        <div class="text-xs-center mt-3 pa-3">
          <v-btn 
            color="secondary"
            large
            v-on:click="joinPressed"
          >
            Accept
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex xs12 display-1 text-xs-center>
        This invitation is not valid.
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data: function () {
    return {
      invitation: null,
      loggedIn: this.$store.getters.loggedIn,
      error: null
    }
  },
  components: {
  },
  mounted: async function () {
    const inviteCode = this.$route.params.code;

    try {
      const result = await AuthenticationService.getInvitationWithCode(inviteCode);

      this.invitation = result.data;

      if (this.$store.getters.loggedIn) {
        // ensure the user logged in is the intended receipient of the invitation
        if (this.$store.getters.user.username !== this.invitation.username) {
          this.error = 'this invitation is not valid for the logged in user';
          return;
        }
      } else {
        // must be logged in to use this view
        // attach the invitation to the state and as the user to log in
        this.$store.dispatch('setLoginRedirect', {
          reason: 'An account exists for your email address. Please log in to join your school.',
          path: this.$router.currentRoute.path,
          username: this.invitation.username
        })
        this.$router.push({
          name: 'login'
        })
        return;
      }
      
    } catch (err) {
      this.error = err.response.data.error;
    }
  },
  methods: {
    async joinPressed () {
      if (!this.invitation) return;

      const invite = this.invitation;
      try {
        const response = await AuthenticationService.joinWithInvitation({
          code: invite.uuid
        })

        this.$store.dispatch('setToken', response.data.token);
        this.$store.dispatch('setUser', response.data.user);

        this.$router.push({
          path: '/'
        })
      } catch (err) {
        console.log(err)
      }
      
    }
  }
}
</script>

<style scoped>

</style>
